"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Csv___StyledSvg",
  componentId: "sc-1971uzb-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function Csv(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.925 3.455h7.25v2.909h2.9v.727h1.45V5.335L13.2 2H4.925c-.8 0-1.45.652-1.45 1.455V7.09h1.45V3.455zM15.075 16.545H4.925v-.727h-1.45v.727c0 .803.65 1.455 1.45 1.455h10.15c.8 0 1.45-.652 1.45-1.455v-.727h-1.45v.727zM7.1 14.364v-1.455H4.925a.727.727 0 01-.725-.727v-1.455c0-.4.325-.727.725-.727H7.1V8.545H4.925c-1.2 0-2.175.98-2.175 2.182v1.455c0 1.203.976 2.182 2.175 2.182H7.1zM9.637 10h2.538V8.545H9.637a1.818 1.818 0 000 3.637h.725a.364.364 0 010 .727H7.825v1.455h2.537a1.817 1.817 0 000-3.637h-.725a.363.363 0 010-.727zM15.758 8.545l-.694 2.838-.714-2.838H12.9l1.423 5.819h1.492l-.015-.06 1.45-5.759h-1.492z",
    fill: "currentColor"
  }));
}

var _default = Csv;
exports["default"] = _default;